var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.currentUser.profile.interface === 'Worker')?_c('worker-create'):_c('create-req')}
var staticRenderFns = []

export { render, staticRenderFns }